<template>
  <div v-if="!dialogFormVisible" class="cangchuCk_pupop">
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      center
      title=""
      :visible.sync="dialogVisible"
      width="1200px"
      @close="reset"
    >
      <div
        style="
          width: 90%;
          margin-left: auto;
          margin-right: auto;
          max-width: 1200px;
          padding-top: 10px;
        "
      >
        <div>
          <el-form
            ref="form"
            :rules="rules"
            label-position="right"
            :model="ckckForm"
            label-width="120px"
          >
            <el-form-item label="委托单位:" prop="wtDwMc">
              <el-select
                v-model="ckckForm.wtDwMc"
                :disabled="(disLabel && childrenType != 'change') || disLabel"
                style="width: 100%"
                placeholder="请选择"
                @change="wtdwCHange"
              >
                <el-option
                  v-for="(item, index) in wtdwXlList"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="化学品:" prop="hxpBm">
              <el-cascader
                :key="hxpChangeIndex"
                v-model="ckckForm.hxpBm"
                :disabled="disLabel"
                :options="hxpDataList"
                style="width: 100%"
                @change="hxpChange"
              />
            </el-form-item>

            <el-form-item label="委托方经办人:" prop="jbName">
              <el-input
                v-model="ckckForm.jbName"
                :disabled="disLabel"
                placeholder="请输入委托方经办人姓名"
              />
            </el-form-item>

            <el-form-item label="经办人电话:" prop="jbPhone">
              <el-input
                v-model="ckckForm.jbPhone"
                :disabled="disLabel"
                placeholder="请输入委托方经办人电话"
              />
            </el-form-item>
            <el-form-item label="存放仓库:" prop="ckId">
              <el-select
                v-model="ckckForm.ckId"
                style="width: 100%"
                :disabled="disLabel && childrenType != 'change'"
                placeholder="请选择"
                @change="cfckChange"
              >
                <el-option
                  v-for="(item, index) in cfckList"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
            <el-form-item v-if="!(disLabel && childrenType != 'change')" label="库存数量:">
              <el-input
                v-model="ckckForm.kcsl"
                disabled
                style="width: 65%"
                placeholder="请输入"
              />
              <el-select
                v-model="ckckForm.kcslDw"
                disabled
                style="width: calc(35% - 10px); margin-left: 10px"
                placeholder="单位"
              >
                <el-option
                  v-for="(item, index) in zldwList"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="出库数量:" prop="cksl">
              <el-input
                v-model="ckckForm.cksl"
                :disabled="disLabel && childrenType != 'change'"
                style="width: 65%"
                placeholder="请输入"
              />
              <el-select
                v-model="ckckForm.ckslDw"
                style="width: calc(35% - 10px); margin-left: 10px"
                placeholder="单位"
                :disabled="disLabel && childrenType != 'change'"
              >
                <el-option
                  v-for="(item, index) in ckslList"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="出库日期:" prop="ckrq">
              <el-date-picker
                v-model="ckckForm.ckrq"
                :disabled="disLabel && childrenType != 'change'"
                style="width: 100%"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="选择日期"
                :picker-options="pickerBeginDateBefore"
              />
            </el-form-item>
            <el-form-item label="车号/次:" style="position: relative">
              <el-input
                v-model="ckckForm.ch"
                :disabled="disLabel"
                placeholder="请输入车号/次"
              />
              <div
                style="
                  position: absolute;
                  right: 2px;
                  top: 0;
                  cursor: pointer;
                  font-size: 20px;
                  color: #5b96ee;
                  height: 30;
                  width: 40px;
                  background: white;
                  margin-top: 4px;
                  text-align: center;
                  line-height: 30px;
                "
                :title="ckckForm.ch"
              >
                <i class="el-icon-more" />
              </div>
            </el-form-item>
            <el-form-item label="经办人:" prop="jbrName">
              <el-select
                v-model="ckckForm.jbrName"
                filterable
                :disabled="(disLabel && childrenType != 'change') || disLabel"
                style="width: 100%"
                placeholder="请选择"
                @change="hchange"
              >
                <el-option
                  v-for="(item, index) in jbrList"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="登记人:">
              <el-input v-model="ckckForm.djr" disabled />
            </el-form-item>
            <el-form-item v-if="djsjshow" label="登记时间:">
              <el-date-picker
                v-model="ckckForm.djsj"
                disabled
                style="width: 100%"
                type="date"
                placeholder="选择日期"
                format="yyyy-MM-dd HH:mm:ss"
              />
            </el-form-item>
            <el-form-item label="备注:" style="width: 100%">
              <el-input
                v-model="ckckForm.bz"
                :disabled="disLabel"
                placeholder="请填写原因"
              />
            </el-form-item>
            <el-form-item
              v-if="biangengShow"
              label="变更理由:"
              style="width: 100%"
              prop="bgly"
            >
              <el-input
                v-model="ckckForm.bgly"
                placeholder="请填写原因"
              />
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="">
        <bgcsOfDetail
          v-if="curRowObj.bgcs >= 1"
          :cur-row-obj="curRowObj"
          :cur-type="curType"
          :bgcs-t-k-name="'仓储出库'"
          @bacsCkXqShow="bacsCkXqShow"
        />
      </div>
      <div v-if="disLabel != true" class="buttonList">
        <el-button
          v-preventReClick
          type="primary"
          @click="saveTemp"
        >暂时保存</el-button>
        <el-button
          v-preventReClick
          type="primary"
          @click="save('01')"
        >出库</el-button>
      </div>
      <div
        v-if="disLabel == true && childrenType != 'change'"
        class="backButton"
      >
        <el-button
          type="primary"
          @click="back"
        >返回</el-button>
      </div>
      <div v-if="childrenType == 'change'" class="backButton">
        <el-button
          v-preventReClick
          type="primary"
          style="background: #4170ff; color: #fff"
          @click="changeBt"
        >变更</el-button>
      </div>
    </el-dialog>
  </div>

  <div v-else class="cangchuCk_pupop">
    <!-- 详情弹框 -->
    <el-dialog :visible.sync="dialogFormVisible" width="1200px" center>
      <bgxqCom
        v-if="dialogFormVisible"
        bgcs-t-k-name="仓储入库"
        :dgcs-xq-id="dgcsXqId"
      />
      <div slot="footer" class="dialog-footer">
        <el-button
          v-preventReClick
          type="primary"
          style="background-color: #4170ff; border: none"
          @click="dialogFormVisible = false"
        >确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import bgxqCom from '@/components/bgxq/bgxqCom.vue'
import bgcsOfDetail from '@/components/bgxq/bgInDetail.vue'

import {
    getWtdw,
    getHxpData,
    ckxxAndKcxx,
    addCk,
    editDraft,
    getCkChangeMsg,
    getCkChange,
    getgetLyrList,
    gethqdw, editDraftTemp, addCkTemp
} from '@/assets/js/ccgl.js'
import { getkv, userInfofLogin } from '@/assets/js/common.js'
export default {
  components: { bgcsOfDetail, bgxqCom },
  props: {
    childrenType: { type: String, default: '' },
    disLabel: { type: Boolean },
    disLabelBg: { type: Boolean },
    djsjshow: { type: Boolean }
  },
  data() {
    const sljiaoyan = (rule, value, callback) => {
      // console.log(this.ckckForm.cksl, this.ckckForm.ckslDw);123 4
      // console.log(this.ckckForm.kcsl, this.ckckForm.kcslDw); 12300 '2'
      // if (!this.ckckForm.ckslDw) {
      //   return callback(new Error("请选择出库数量单位"));
      // }
      if (!(this.ckckForm.cksl + '')) {
        return callback(new Error('请选择出库数量'))
      }
      if (this.childrenType != 'change' && this.ckckForm.cksl < 0) {
        return callback(new Error('出库数量不能为负数'))
      }
      const reg1 = /^-?[1-9]\d{0,9}(\.\d{1,3})?$|^-?0(\.\d{1,3})?$/
      if (!reg1.test(this.ckckForm.cksl)) {
        return callback(new Error('整数位最大长度9位,保留3位小数'))
      }
      if (this.ckckForm.ckslDw === this.ckckForm.kcslDw) {
        if (this.ckckForm.cksl > this.ckckForm.kcsl) { return callback(new Error('出库数量不能超过当前库存')) }
      }else if (!this.ckckForm.ckslDw) {
        callback(new Error('请选择出库数量单位!'))
      }
      callback()
    }
    return {
      pickerBeginDateBefore: {
        disabledDate(time) {
          return time.getTime() > Date.now()
        }
      },
      hxpChangeIndex: 1,
      wtdwXlList: [], // 委托单位下拉
      hxpDataList: [], // 化学品下拉
      cfckList: [], // 存放仓库下拉
      zldwList: [], // 重量单位列表
      ckslList: [], // 出库数量单位列表

      jbrList: [], // 经办人下拉
      dialogVisible: false,
      ckckForm: {
        wtDwMc: '', // 往来单位id
        hxpBm: '', // 化学品编码
        jbName: '', // 经办人
        jbPhone: '', // 经办人电话
        ckId: '', // 仓库id
        cksl: '', // 出库数量
        ckslDw: '', // 出库数量单位
        ckrq: '', // 出库日期
        ch: '', // 车次
        djr: '', // 登记人
        djsj: '', // 登记时间
        bz: '', // 备注
        zt: '', // 状态
        kcsl: '', // 库存数量
        kcslDw: '', // 库存数量单位
        /*  */
        ztStr: '',
        ckMc: '',
        hxpMc: '',
        id: '',
        jbrName: '', // 经办人
        jbrId: '',
        bgyId: '',
        bgyxm: '',
        bgydh: '',
        bgly: ''
      },
      rules: {
        wtDwMc: [{ required: true, message: '请选择', trigger: 'change' }],
        jbrName: [{ required: true, message: '请选择', trigger: 'change' }],
        hxpBm: [{ required: true, message: '请选择', trigger: 'change' }],
        jbName: [{ required: true, message: '请输入', trigger: 'change' }],
        jbPhone: [{ required: true, message: '请输入', trigger: 'change' }],
        bgly: [{ required: true, message: '请选择', trigger: 'change' }],
        ckId: [{ required: true, message: '请选择', trigger: 'change' }],
        cksl: [{ required: true, validator: sljiaoyan, trigger: ['blur','change'] }],
        ckrq: [{ required: true, message: '请选择', trigger: ['blur','change'] }]
      },

      biangengShow: false, // 变更显示文本框

      curType: '',
      curRowObj: {}, // 当前行的对象
      dialogFormVisible: false,
      dgcsXqId: null
    }
  },
  computed: {},
  watch: {
    'ckckForm.wtDwMc': {
      handler(curVal, oldVal) {
        if (curVal) {
          getHxpData(curVal).then((e) => {
            this.hxpDataList = e.data.data
          })
        } else this.hxpDataList = []
      },
      deep: true,
      immediate: true
    },
    'ckckForm.hxpBm': {
      handler(curVal, oldVal) {
        if (curVal) {
          if (typeof curVal === 'string' && curVal.constructor === String) {
            gethqdw(curVal).then((res) => {
              this.ckslList = res.data.data
            })
          } else {
            gethqdw(curVal[curVal.length - 1]).then((res) => {
              this.ckslList = res.data.data
            })
          }
        } else this.ckslList = []
        if (this.ckckForm.wtDwMc && this.ckckForm.hxpBm) {
          let val = this.ckckForm.hxpBm
          if (Array.isArray(val)) val = val[val.length - 1]
          ckxxAndKcxx(this.ckckForm.wtDwMc, val).then((e) => {
            this.cfckList = e.data.data
            this.cfckChange(this.ckckForm.ckId)
          })
        } else this.cfckList = []
      },
      deep: true,
      immediate: true
    },
    hxpDataList: {
      handler(curVal, oldVal) {
        this.hxpChangeIndex++ // 绑定的key值用于改变级联数据时重新渲染组件
      },
      deep: true,
      immediate: true
    }
  },
  created() {},
  mounted() {
    this.loadLabel()
  },
  beforeDestroy() {},
  methods: {
    bacsCkXqShow(id) {
      this.dgcsXqId = id
      this.dialogFormVisible = !this.dialogFormVisible
    },
    initCon(curRow, curType) {
      this.curRowObj = curRow
      this.curType = curType
      this.$refs['form'].clearValidate()
    },
    hchange(data) {
      this.jbrList.forEach((item) => {
        if (item.value == data) {
          this.ckckForm.jbrName = item.label
          this.ckckForm.jbrId = item.value
        }
      })
    },
    // 委托单位改变
    wtdwCHange(val) {
      if (this.childrenType == 'change') {
        return
      } else {
        this.ckckForm.hxpBm = ''
        this.ckckForm.hxpMc = ''
        this.ckckForm.ckMc = ''
        this.ckckForm.ckId = ''
        this.ckckForm.kcsl = ''
        this.ckckForm.kcslDw = ''
      }
    },
    // 化学品改变
    hxpChange(val) {
      this.ckckForm.ckMc = ''
      this.ckckForm.ckId = ''
      // this.ckckForm.jbrName = "";
      this.ckckForm.kcsl = ''
      this.ckckForm.kcslDw = ''
      // if (Array.isArray(val)) val = val[val.length - 1];
    },
    cfckChange(val) {
      this.ckckForm.ckMc = ''
      this.ckckForm.kcsl = ''
      this.ckckForm.kcslDw = ''
      this.ckckForm.ckId = val
      this.cfckList.filter((item, index) => {
        if (item.value == val) {
          this.ckckForm.kcsl = item.kcl
          this.ckckForm.kcslDw = item.kclDw
          this.ckckForm.ckMc = item.label

          this.ckckForm.bgyxm = item.ckbgy
          this.ckckForm.bgydh = item.ckbgyDh
        }
      })
    },
    changeBt() {
      this.ckckForm.cksl = this.ckckForm.cksl - 0
      getCkChangeMsg(this.ckckForm).then((e) => {
        if (e.data.data.type == 'success') {
          getCkChange(this.ckckForm).then((rs) => {
            if (rs.data.code == '000000') {
              this.$message({
                type: 'success',
                message: '变更成功'
              })
              this.reset()
              this.dialogVisible = false
              this.$parent.loadDataSource()
            }
          })
        } else if (e.data.data.type == 'danger') {
          this.$confirm(e.data.data.msg, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'danger'
          })
            .then(() => {
              getCkChange(this.ckckForm).then((rs) => {
                if (rs.data.code == '000000') {
                  this.$message({
                    type: 'success',
                    message: '变更成功'
                  })
                  this.reset()
                  this.dialogVisible = false
                  this.$parent.loadDataSource()
                }
              })
            })
            .catch(() => {
              this.$message({
                type: 'info',
                message: '变更失败'
              })
            })
        }
      })
    },
      //暂时保存
    saveTemp() {
        this.$confirm('此操作将提交您的修改, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        })
            .then(() => {
                this.ckckForm.zt = '00'
                if (this.childrenType == 'copy') { this.$delete(this.ckckForm, 'id') }
                if (Array.isArray(this.ckckForm.hxpBm)) {
                    this.ckckForm.hxpBm =
                        this.ckckForm.hxpBm[this.ckckForm.hxpBm.length - 1]
                }
                if (this.childrenType == 'edit') {
                    editDraftTemp(this.ckckForm).then((e) => {
                        if (e.data.code == '000000') {
                            this.$message({
                                type: 'success',
                                message: '提交成功'
                            })
                            this.reset()
                            this.dialogVisible = false
                            this.$parent.loadDataSource()
                        }
                    })
                    return
                } else if (
                    this.childrenType == 'add' ||
                    this.childrenType == 'copy'
                ) {
                    addCkTemp(this.ckckForm).then((e) => {
                        if (e.data.code == '000000') {
                            this.$message({
                                type: 'success',
                                message: '提交成功'
                            })
                            this.reset()
                            this.dialogVisible = false
                            this.$parent.loadDataSource()
                        }
                    })
                }
            })
            .catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消提交'
                })
            })
    },
    //出库保存
    save(type) {
      this.$refs['form'].validate((valid, obj) => {
        if (valid) {
          this.$confirm('此操作将提交您的修改, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
            .then(() => {
              this.ckckForm.zt = type
              if (this.childrenType == 'copy') { this.$delete(this.ckckForm, 'id') }
              if (Array.isArray(this.ckckForm.hxpBm)) {
                this.ckckForm.hxpBm =
                  this.ckckForm.hxpBm[this.ckckForm.hxpBm.length - 1]
              }
              if (this.childrenType == 'edit') {
                editDraft(this.ckckForm).then((e) => {
                  if (e.data.code == '000000') {
                    this.$message({
                      type: 'success',
                      message: '提交成功'
                    })
                    this.reset()
                    this.dialogVisible = false
                    this.$parent.loadDataSource()
                  }
                })
                return
              } else if (
                this.childrenType == 'add' ||
                this.childrenType == 'copy'
              ) {
                addCk(this.ckckForm).then((e) => {
                  if (e.data.code == '000000') {
                    this.$message({
                      type: 'success',
                      message: '提交成功'
                    })
                    this.reset()
                    this.dialogVisible = false
                    this.$parent.loadDataSource()
                  }
                })
              }
            })
            .catch(() => {
              this.$message({
                type: 'info',
                message: '已取消提交'
              })
            })
        }
      })
    },
    loadLabel() {
      // 获取往来单位
      getWtdw().then((e) => {
        this.wtdwXlList = e.data.data
      })
      // 获取重量单位
      getkv('yzd_nsjsl_dw').then((e) => {
        this.zldwList = e.data.data
      })
      // 获取用户信息
      userInfofLogin().then((e) => {
        this.ckckForm.djr = e.data.data.name
        this.ckckForm.djsj = this.getDate()
      })
      getgetLyrList().then((res) => {
        this.jbrList = res.data.data
      })
    },
    // 重置
    reset() {
      this.ckckForm = this.$options.data().ckckForm
      this.ckslList = []
      this.hxpDataList = [] // 化学品下拉
      this.cfckList = [] // 存放仓库下拉
      setTimeout(() => {
        this.$refs['form'].clearValidate()
      }, 30)
    },
    // 返回按钮
    back() {
      // this.reset();
      this.dialogVisible = false
    },
    getDate() {
      var date = new Date()
      var year = date.getFullYear()
      var month =
        date.getMonth() + 1 < 10
          ? '0' + (date.getMonth() + 1)
          : date.getMonth() + 1
      var day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
      // 拼接
      return year + '-' + month + '-' + day
    }
  }
}
</script>
<style scoped lang='less'>
.cangchuCk_pupop {
  .el-form {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    .el-form-item {
      width: 45%;
    }
  }
  .buttonList {
    width: 498px;
    margin-left: auto;
    margin-right: auto;
    margin-top: 30px;
    margin-bottom: 40px;
    display: flex;
    justify-content: center;
    .el-button:nth-child(1) {
      margin-right: 190px;
      background-color: #ebebeb;
      width: 148px;
      height: 60px;
      color: #333333;
      border: none;
    }
    .el-button:nth-child(2) {
      background-color: #4170ff;
      color: white;
      width: 148px;
      height: 60px;
      border: none;
    }
  }
  .backButton {
    width: 148px;
    margin: 30px auto 40px auto;
    .el-button {
      margin: auto;
      background-color: #ebebeb;
      width: 148px;
      height: 60px;
      color: #333333;
      border: none;
    }
  }
}
</style>
